import { Component, Output, EventEmitter, input, model, inject, computed, output, OnInit, effect } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { JsonPipe } from '@angular/common';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatButtonModule } from '@angular/material/button';
import { TextFieldModule } from '@angular/cdk/text-field';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';

import { AuthService, LogService } from 'src/app/services';
import { BookService } from 'src/app/services/book.service';
import { Book } from '../../_models';
import { GenreChipsComponent } from '../chips/genre-chips/genre-chips.component';
import { NarratorChipsComponent } from '../chips/narrator-chips/narrator-chips.component';
import { AuthorChipsComponent } from '../chips/author-chips/author-chips.component';
import { HasReadChipsComponent } from '../chips/has-read-chips/has-read-chips.component';
import { IsInterestedChipsComponent } from '../chips/is-interested-chips/is-interested-chips.component';
import { SeriesListComponent } from '../series-list/series-list-chips/series-list.component';
import { RecommendationListComponent } from '../reccs/recommendation-list/recommendation-list.component';
import { concatAll } from 'rxjs';

@Component({
  selector: 'kbm-book-add-edit',
  templateUrl: './book-add-edit.component.html',
  styleUrls: ['./book-add-edit.component.scss'],
  standalone: true,
  imports: [
    MatFormFieldModule,
    MatInputModule,
    TextFieldModule,
    MatButtonModule,
    JsonPipe,
    MatDatepickerModule,
    MatCheckboxModule,
    MatDialogModule,
    MatSelectModule,
    AuthorChipsComponent,
    NarratorChipsComponent,
    GenreChipsComponent,
    IsInterestedChipsComponent,
    HasReadChipsComponent,
    SeriesListComponent,
    RecommendationListComponent,
    FormsModule,
    ReactiveFormsModule,
  ]
})
export class BookAddEditComponent implements OnInit {

  book = model.required<Book>();
  crudMode = input.required<'UPDATE' | 'CREATE'>();

  @Output()
  addSaveEvent: EventEmitter<'ADD' | 'SAVE' | 'CANCEL' | 'DELETE'> = new EventEmitter();

  authService = inject(AuthService);
  bookService = inject(BookService);
  dialog = inject(MatDialog);
  logService = inject(LogService);
  fb = inject(FormBuilder);


  isAuthenticated = computed(() => {
    return this.authService.isLoggedIn();
  });


  hasRead: string[] = [''];
  isInterested: string[] = [''];

  allUsers: string[] = [''];

  me: string | null = sessionStorage.getItem('username');

  bookForm = this.fb.group({
    amazon_id: ['', { Validators: [Validators.required] }],
    title: ['', { Validators: [Validators.required] }],
    type: [''],
    authors: [['']],
    narrators: [['']],
    genres: [['']],
    purchaseDate: [''],
    publicationDate: [''],
    publisher: [''],
    runningTime: [''],
    // series: [[{}],],
    coverImageUrl: [''],
    amazonPageUrl: [''],
    description: [''],
    //recommendations: [],
    whispersync: [''],
    addedBy: [''],
    //hasRead: [''],
    //isInterested: [''],
  });


  constructor() {
    this.loadUserList();
  }


  ngOnInit(): void {
    this.bookForm.patchValue({
      amazon_id: this.book().amazon_id,
      title: this.book().title,
      type: this.book().type,
      coverImageUrl: this.book().coverImageUrl,
      purchaseDate: this.book().purchaseDate,
      publicationDate: this.book().publicationDate,
      publisher: this.book().publisher,
      runningTime: this.book().runningTime,
      description: this.book().description,
      // series: this.book().series ? this.book().series : [],
      //recommendations: this.book().recommendations,
      whispersync: this.book().whispersync,
      addedBy: this.book().addedBy,
      //hasRead: this.book().hasRead,
      //isInterested: this.book().isInterested,

      authors: this.book().authors,
      narrators: this.book().narrators,
      genres: this.book().genres,
    })
  }


  dateConvert(inDate: Date): string {
    // Fri Jun 14 2024 00:00:00 GMT-0700  ---> 2024-06-14
    const year = inDate.getFullYear();
    const month = (inDate.getMonth() + 1).toString().trim().padStart(2, '0');
    const day = inDate.getDate().toString().trim().padStart(2, '0');
    return year + '-' + month + '-' + day
  }

  onActionButtonClick(updateType: 'ADD' | 'SAVE' | 'CANCEL' | 'DELETE') {
    if (updateType === 'ADD' || updateType === 'SAVE') {

      this.book.update(cur => {
        const formValue = this.bookForm.value as Partial<Book>;
        return {
          ...cur,
          amazon_id: formValue.amazon_id || '',
          title: formValue.title || '',
          type: formValue.type || '',
          authors: formValue.authors || [],
          narrators: formValue.narrators || [],
          genres: formValue.genres || [],
          purchaseDate: formValue.purchaseDate || '',
          publicationDate: formValue.publicationDate || '',
          publisher: formValue.publisher || '',
          runningTime: formValue.runningTime || '',
          description: formValue.description || '',
          coverImageUrl: formValue.coverImageUrl || '',
          amazonPageUrl: formValue.amazonPageUrl || '',
          addedBy: formValue.addedBy || '',
          // series: formValue.series || [],
          // recommendations: formValue.recommendations || [],
          //hasRead: formValue.hasRead || [],

          //isInterested: formValue.isInterested || [],
          whispersync: formValue.whispersync || '',
        };
      });
          
    }
    this.addSaveEvent.emit(updateType);
  }

  async loadUserList() {
    try {
      const users = await this.bookService.getUsers();
      this.allUsers = users.map(u => u.username);
    }
    catch (err) {
      this.logService.error(JSON.stringify(err));
      console.log(err);
    }
  }


  getDiagnostic() {
    //return this.bookForm.value.series;
    //return this.book().series;
    //return this.bookForm.value;
    return this.book()
  }
}
